import config from '@config';
import { ApplicationState, HowToHelpType } from '@shared/enums';
import { ExtendedUser } from '@shared/types/common.types';
import { VolunteerFilters } from '@store/slices/volunteer/slice';

export const HAND_TO_HAND = 'hand';
export const ONLINE_MEDICINE = 'online';

export const CABINET_TAB_NEW = 'new';
export const CABINET_TAB_VERIFYING = 'in_progress';
export const CABINET_TAB_PERFORM = 'processed';

export const WHO_NEED_HELP_ALL = 'all';
export const WHO_NEED_HELP_ORGANIZATION = 'organization';
export const WHO_NEED_HELP_PRIVATE_PERSON = 'private-person';

interface CabinetTabData {
  eventKey: ApplicationState;
  isActive: boolean;
  label: string;
  indication: null | number;
  isAllowed: (
    user: ExtendedUser | null,
    /**
     * HACK: we need this code temporary to show users santa-claus-letter tab
     *
     * TODO: remove this
     */
    filters?: VolunteerFilters,
  ) => boolean;
}

const isAllowedToShowTab = (filters?: VolunteerFilters) => {
  const { category } = filters || {};

  if (category === HowToHelpType.SantaClausLetter) {
    return false;
  }

  if (category === HowToHelpType.Easter) {
    return config.features.easterPayApplication;
  }

  return true;
};

export const cabinetTabsData: readonly CabinetTabData[] = [
  {
    eventKey: ApplicationState.New,
    isActive: false,
    label: 'active',
    indication: null,
    /**
     * HACK: We hide 'new', 'processed' and 'in_progress' tabs for volunteers in the Santa Claus Letter tab.
     */
    isAllowed: (_, filters) => isAllowedToShowTab(filters),
  },
  {
    eventKey: ApplicationState.InProgress,
    isActive: false,
    label: 'verified',
    indication: null,
    isAllowed: (user, filters) => (isAllowedToShowTab(filters) ? !!user && user.isMember : false),
  },
  {
    eventKey: ApplicationState.Processed,
    isActive: false,
    label: 'in-progress',
    indication: null,
    isAllowed: (user, filters) => (isAllowedToShowTab(filters) ? !!user && user.isMember : false),
  },
  {
    eventKey: ApplicationState.Completed,
    isActive: false,
    label: 'completed',
    indication: null,
    isAllowed: (user) => !!user && user.isMember,
  },
] as const;

export const ALL = 'all';
export const checkboxShowAll = { id: ALL, name: 'All', isChecked: true };
